module.exports = __webpack_public_path__ + "static/rick-artist-profile-a441ed55561d5c13b3056d55cb106d1b.jpg";